import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "templateSelect", "applyMarker", "subjectInput", "submitButton", "status"]
  static values = { focusSubject: Boolean }

  connect() {
    this.handleSubmitStart = this.handleSubmitStart.bind(this)
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.formElement = this.formTarget
    this.formElement.addEventListener("turbo:submit-start", this.handleSubmitStart)
    this.formElement.addEventListener("turbo:submit-end", this.handleSubmitEnd)
    this.focusHandle = null
    this.activeSubmission = null
    this.controlStates = null
    this.focusedElement = null

    if (this.focusSubjectValue) {
      this.focusHandle = requestAnimationFrame(() => {
        this.focusHandle = null
        if (this.hasSubjectInputTarget) this.subjectInputTarget.focus()
      })
      this.focusSubjectValue = false
    }
  }

  disconnect() {
    this.formElement.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.formElement.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
    this.restoreControls()
    this.element.removeAttribute("aria-busy")
    if (this.hasApplyMarkerTarget) this.applyMarkerTarget.value = "0"
    this.activeSubmission = null
    this.focusedElement = null

    if (this.focusHandle !== null) cancelAnimationFrame(this.focusHandle)
  }

  applyTemplate() {
    this.applyMarkerTarget.value = "1"
    this.formTarget.requestSubmit()
  }

  handleSubmitStart(event) {
    if (!this.applyingTemplate()) return

    if (!this.activeSubmission) this.captureControlStates()
    this.activeSubmission = event.detail.formSubmission
    this.focusedElement = document.activeElement
    this.element.setAttribute("aria-busy", "true")
    this.disableControls()
    this.statusTarget.textContent = "Chargement du modèle…"
  }

  handleSubmitEnd(event) {
    if (!this.activeSubmission || event.detail.formSubmission !== this.activeSubmission) return

    const failed = event.detail.fetchResponse ? !event.detail.fetchResponse.succeeded : event.detail.success === false
    this.restoreControls()
    this.applyMarkerTarget.value = "0"
    this.element.removeAttribute("aria-busy")
    this.activeSubmission = null

    if (failed) {
      this.statusTarget.textContent = "Échec de la requête."
      if (this.formElement.isConnected && this.focusedElement?.isConnected) this.focusedElement.focus()
    }
    this.focusedElement = null
  }

  applyingTemplate() {
    return this.applyMarkerTarget.value === "1"
  }

  captureControlStates() {
    this.controlStates = Array.from(this.formElement.elements).map((control) => ({
      control,
      disabled: control.disabled
    }))
  }

  disableControls() {
    this.controlStates.forEach(({ control }) => (control.disabled = true))
  }

  restoreControls() {
    this.controlStates?.forEach(({ control, disabled }) => (control.disabled = disabled))
    this.controlStates = null
  }
}
